export enum AnalogueFilterTypes {
  ANALOGUE = 1,
  PARTNERS,
  ALL
}
